<!-- src/components/OnlinePagination.vue -->
<script setup>
defineOptions({ name: 'OnlinePagination' });

import { computed } from 'vue';
import { useGamesStore } from '../../stores/games/gamesStore';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  gamesPerPage: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['update:currentPage']);
const gamesStore = useGamesStore();

const totalPages = computed(() => 
  Math.ceil(gamesStore.games.length / props.gamesPerPage)
);

const hasMoreGames = computed(() => 
  props.currentPage < totalPages.value
);

const loadMore = () => {
  if (hasMoreGames.value) {
    emit('update:currentPage', props.currentPage + 1);
  }
};
</script>

<template>
  <div class="load-more-wrapper" v-if="hasMoreGames">
    <button @click="loadMore" class="load-more-button">
      <span class="button-text">{{ t('pagination.loadMoreGames') }} </span>
      <font-awesome-icon :icon="['fas', 'spinner']" 
                        class="loading-icon" 
                        v-if="gamesStore.isLoading" />
    </button>
    <div class="games-remaining">
      {{ t('pagination.show') }} {{ currentPage * gamesPerPage }} {{ t('pagination.of') }} {{ gamesStore.games.length }}  {{ t('pagination.games') }}
    </div>
  </div>
</template>
<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
</style>
